import React from 'react'
import { Button, Container } from 'react-bootstrap'
import { useNavigate } from "react-router-dom";
import { ASSETS_URL } from '../api/constants';

function HomeCTA({ section }) {
  const token = localStorage.getItem("token");
  const navigate = useNavigate();

  // Default fallback values
  const title = section?.title || "Get home recommendations";
  const subtitle = section?.subtitle || "Sign in for a more personalized experience.";
  const btn_name = section?.btn_name || "Sign In / Register";
  const btn_link = section?.btn_link || "/sign-in";
  
  // Build background image URL
  const backgroundImage = section?.image 
    ? `url(${ASSETS_URL}${section.image})`
    : 'url(../assets/images/home-cta-bg.png)';
  
  const ctaStyle = {
    backgroundImage: backgroundImage,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    backgroundSize: 'cover'
  };

  const handleButtonClick = () => {
    if (btn_link.startsWith('http://') || btn_link.startsWith('https://')) {
      window.location.href = btn_link;
    } else {
      navigate(btn_link);
    }
  };

  return (
    <>
     <div className="home-cta common-padding" style={ctaStyle}>
      <Container>
        <div className='home-cta-wrap'>
          <div className='text-wrap'>
            <h2>{title}</h2>
            {token ? (
              <p>Browse your favorite listings.</p>
            ) : (
              <p>{subtitle}</p>
            )}
          </div>
          {!token && (
            <Button className='custom-bttn style-1 ml-20' onClick={handleButtonClick}>
              {btn_name}
            </Button>
          )}
        </div>
      </Container>
     </div>
    </>
  )
}
export default HomeCTA